import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '17864808238';
const DEFAULT_MESSAGE = "Hi, I'm interested in your CAD drafting services. Can you help?";

const WhatsAppButton = () => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float group"
      data-testid="whatsapp-chat-button"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.132 6.744 3.054 9.378L1.056 31.2l6.06-1.94a15.9 15.9 0 008.888 2.684C24.826 31.944 32 24.77 32 16.004S24.826 0 16.004 0zm9.312 22.618c-.39 1.1-1.932 2.014-3.168 2.282-.848.18-1.954.324-5.68-1.22-4.768-1.974-7.834-6.81-8.072-7.126-.228-.316-1.916-2.552-1.916-4.868 0-2.316 1.214-3.454 1.644-3.926.39-.428 1.024-.624 1.63-.624.198 0 .374.01.534.018.468.02.704.048 1.012.786.39.93 1.338 3.246 1.456 3.482.118.238.236.554.078.87-.148.316-.278.514-.516.788-.238.276-.5.614-.712.824-.238.236-.486.494-.208.968.276.474 1.23 2.028 2.642 3.286 1.814 1.618 3.344 2.12 3.818 2.358.474.238.752.198 1.028-.118.276-.316 1.196-1.392 1.514-1.87.316-.474.634-.394 1.068-.236.434.158 2.75 1.298 3.222 1.534.474.238.788.354.906.554.118.198.118 1.15-.272 2.248z"/>
      </svg>
      <span className="whatsapp-tooltip">Chat with us</span>
    </a>
  );
};

export default WhatsAppButton;
